export default __webpack_public_path__ + "static/media/calendar.ede91bf5.svg";